import React from "react";
import { useMutation } from "@apollo/client";
import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../AskVyrillReducer";
import { updateAskVyrillState } from "../Actions";
import { DELETE_CONVERSATION_MUTATION } from "../../../Queries/ask-vyrill";
import { updateConfirmationModalState } from "../../../Shared/PopUpModals/Actions";

interface HistoryActionProps {
  id: string;
  isEdit: { id: string; value: string };
  value: string;
  handleEdit: () => void;
  setIsEdit: React.Dispatch<
    React.SetStateAction<{ id: string; value: string }>
  >;
}

interface MyObject {
  _id: string;
}

const HistoryAction: React.FC<HistoryActionProps> = ({
  id,
  value,
  isEdit,
  handleEdit,
  setIsEdit,
}) => {
  const allConversations = useSelector(
    (state: RootState) => state.askVyrill?.allConversations
  );
  const [deleteConversation] = useMutation(DELETE_CONVERSATION_MUTATION);
  const dispatch = useDispatch();

  const handleConfirmation = () => {
    const func = () => {
      deleteConversation({
        variables: {
          conversationId: id,
        },
      })
        .then((result) => {
          if (result?.data?.deleteConversation) {
            const newArray = allConversations.filter(
              (obj: MyObject) => obj._id !== id
            );
            dispatch(
              updateConfirmationModalState({
                shouldOpen: false,
                message: "",
                loading:false
              })
            );

            dispatch(
              updateAskVyrillState({
                allConversations: newArray,
              })
            );
          }
        })
        .catch((error) => {
          // Handle any errors that occurred during the mutation
          console.error("Error deleting conversation:", error);
        });
    };

    dispatch(
      updateConfirmationModalState({
        shouldOpen: true,
        message: "Are you sure you want to delete the chat session?",
        func,
      })
    );
  };

  return (
    <div className="history-action">
      {isEdit.id === id ? (
        <>
          <span role="button" onClick={handleEdit}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="15"
              width="15"
              viewBox="0 0 512 512"
            >
              <path
                fill="#9e9e9e"
                d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 48c110.5 0 200 89.5 200 200 0 110.5-89.5 200-200 200-110.5 0-200-89.5-200-200 0-110.5 89.5-200 200-200m140.2 130.3l-22.5-22.7c-4.7-4.7-12.3-4.7-17-.1L215.3 303.7l-59.8-60.3c-4.7-4.7-12.3-4.7-17-.1l-22.7 22.5c-4.7 4.7-4.7 12.3-.1 17l90.8 91.5c4.7 4.7 12.3 4.7 17 .1l172.6-171.2c4.7-4.7 4.7-12.3 .1-17z"
              />
            </svg>
          </span>
          <img
            src={require("@src/assets/images/vyrill/cross.png").default}
            alt=""
            width="15px"
            role="button"
            onClick={() =>
              setIsEdit({
                id: "",
                value: "",
              })
            }
          />
        </>
      ) : (
        <>
          <img
            src={require("@src/assets/images/vyrill/edit.png").default}
            alt=""
            width="11px"
            role="button"
            onClick={() =>
              setIsEdit({
                id,
                value,
              })
            }
          />
          <img
            src={require("@src/assets/images/vyrill/delete.png").default}
            alt=""
            width="11px"
            role="button"
            onClick={handleConfirmation}
          />
        </>
      )}
    </div>
  );
};

export default HistoryAction;
